import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Abtimg01 from "../../../assets/images/shape/about-shape-1.png";
import Abtimg02 from "../../../assets/images/shape/about-shape-2.png";
// Fotos reales del banco de imagenes de la marca, optimizadas para web.
// Antes: una ilustracion generada por IA con texto inventado
// ("SEUFILITY INTELIGENCE") que restaba credibilidad en un sitio de pagos.
import Abtimg03 from "../../../assets/images/about/caprim-pareja-movil.jpg";
import Abtimg04 from "../../../assets/images/about/caprim-persona-vertical.jpg";

const Aboutone = () => {
  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll(".about-one-image");

      elements.forEach((el) => {
        const elementTop = el.getBoundingClientRect().top;
        const elementBottom = el.getBoundingClientRect().bottom;
        const viewportTop = 0;
        const viewportBottom = window.innerHeight;

        if (elementBottom > viewportTop && elementTop < viewportBottom) {
          el.classList.add("active");
        }
      });
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll(".about-one_image");

      elements.forEach((el) => {
        const elementTop = el.getBoundingClientRect().top;
        const elementBottom = el.getBoundingClientRect().bottom;
        const viewportTop = 0;
        const viewportBottom = window.innerHeight;

        if (elementBottom > viewportTop && elementTop < viewportBottom) {
          el.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <div className="about-one">
      <div className="about-one-shape-1">
        <img src={Abtimg01} alt="shape" />
      </div>
      <div className="about-one-shape-2">
        <img src={Abtimg02} alt="shape" />
      </div>
      <div className="container">
        <div className="row gutter-y-30">
          <div className="col-xl-9 col-lg-8">
            <div className="heading-box">
              <span className="heading-subtitle wow fadeInUp animated animated">
              Acerca de nosotros
              </span>
              <div className="heading-title wow fadeInUp animated animated">
                <h2>La forma más eficiente de mover el dinero de tu empresa</h2>
              </div>
            </div>
            <div className="row gutter-y-30">
              <div className="col-xl-5 col-lg-12">
                <div className="about-one-image">
                  <img src={Abtimg03} alt="about-image" />
                  <div className="image-shape">
                    <span />
                    <span />
                  </div>
                </div>
              </div>
              <div className="col-xl-7 col-lg-12">
                <div className="about-one-info">
                  <div className="section-details">
                    <p>
                      En Caprim ayudamos a empresas de e-commerce, remesas,
                      importación y exportación a recibir pagos, pagarle a
                      quien lo necesiten, y mover dinero entre Colombia,
                      Estados Unidos y China de forma ágil y eficiente.
                    </p>
                    <p>
                      Nos enfocamos en que tus finanzas sean lo más eficientes
                      posibles: en tiempo, en costos y en la infraestructura
                      que las soporta.
                    </p>
                    <p>
                      Hoy procesamos más de USD 10 millones al mes para
                      empresas en Colombia, y seguimos construyendo la
                      infraestructura para conectarte con el resto del mundo.
                    </p>
                    <Link to="/Contactus" className="btn btn-outline-secondary">
                      Hablemos <i className="flaticon-next" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-4 d-lg-block d-none">
            <div className="about-one_image">
              <img src={Abtimg04} alt="about-image" />
              <div className="image-shape">
                <span />
                <span />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Aboutone;
